import XButton from "./XButton";
import UploadTemplate from "../../assets/icons/UploadTemplate.svg?react";
import UploadTemplateBlue from "../../assets/icons/UploadTemplateBlue.svg?react";
import RemoveCustomFileIcon from "../../assets/icons/RemoveCustomFileIcon.svg?react";
import DownloadButtonIcon from "../../assets/icons/DownloadButtonIcon.svg?react";
import useFileOpener from "../../hooks/useFileOpener";


const TemplateFileCell = ({ hasFile, filename, onUpload, onDelete, file }) => {
    const { openFileInNewTab } = useFileOpener();
    if (!hasFile) {
        return (
            <XButton onClick={onUpload}>
                <UploadTemplateBlue />
                Upload Template
            </XButton>
        );
    }

    return (
        <div className="flex justify-between">
            <span className="flex items-center gap-2">
                <UploadTemplate />
                <span className="whitespace-nowrap overflow-hidden text-ellipsis">{filename}</span>
            </span>
            <div className="flex gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <XButton variant="iconOutline" onClick={() => openFileInNewTab(file)} aria-label="Download template file">
                    <DownloadButtonIcon />
                </XButton>
                <XButton variant="iconOutline" onClick={onDelete} aria-label="Remove template file">
                    <RemoveCustomFileIcon className="text-primary" />
                </XButton>
            </div>
        </div>
    );
};

export default TemplateFileCell;
